import { render, staticRenderFns } from "./PoliceRecord.vue?vue&type=template&id=bb613c64&scoped=true"
import script from "./PoliceRecord.vue?vue&type=script&lang=js"
export * from "./PoliceRecord.vue?vue&type=script&lang=js"
import style0 from "./PoliceRecord.vue?vue&type=style&index=0&id=bb613c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb613c64",
  null
  
)

export default component.exports